var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { RelayUrlsProvider } from './RelayUrlsProvider';
import { InvalidHostId, RelayUnreachable } from './UhstErrors';

var ApiClient = function () {
  function ApiClient(relayClientProvider, relayUrlsProvider) {
    this.relayClientProvider = relayClientProvider;
    this.relayUrlsProvider = relayUrlsProvider !== null && relayUrlsProvider !== void 0 ? relayUrlsProvider : new RelayUrlsProvider();
  }

  ApiClient.prototype.initHost = function (hostId) {
    return __awaiter(this, void 0, void 0, function () {
      var relayUrl, hostConfiguration, exception, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.relayUrlsProvider.getBestRelayUrl(hostId)];

          case 1:
            relayUrl = _a.sent();
            exception = new RelayUnreachable();
            _a.label = 2;

          case 2:
            _a.trys.push([2, 4,, 5]);

            this.relayClient = this.relayClientProvider.createRelayClient(relayUrl);
            return [4
            /*yield*/
            , this.relayClient.initHost(hostId)];

          case 3:
            hostConfiguration = _a.sent();
            return [3
            /*break*/
            , 5];

          case 4:
            e_1 = _a.sent(); // handle network error here

            exception = e_1;
            return [3
            /*break*/
            , 5];

          case 5:
            return [2
            /*return*/
            , new Promise(function (resolve, reject) {
              if (hostConfiguration) {
                resolve(hostConfiguration);
              } else {
                reject(exception);
              }
            })];
        }
      });
    });
  };

  ApiClient.prototype.initClient = function (hostId) {
    return __awaiter(this, void 0, void 0, function () {
      var relayUrls, clientConfiguration, exception, _i, relayUrls_1, url, e_2;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.relayUrlsProvider.getRelayUrls(hostId)];

          case 1:
            relayUrls = _a.sent();
            exception = new RelayUnreachable();
            _i = 0, relayUrls_1 = relayUrls;
            _a.label = 2;

          case 2:
            if (!(_i < relayUrls_1.length)) return [3
            /*break*/
            , 7];
            url = relayUrls_1[_i];
            _a.label = 3;

          case 3:
            _a.trys.push([3, 5,, 6]);

            this.relayClient = this.relayClientProvider.createRelayClient(url);
            return [4
            /*yield*/
            , this.relayClient.initClient(hostId)];

          case 4:
            clientConfiguration = _a.sent();
            return [3
            /*break*/
            , 7];

          case 5:
            e_2 = _a.sent(); // handle network error here

            exception = e_2;

            if (e_2 instanceof InvalidHostId) {
              return [3
              /*break*/
              , 7];
            }

            return [3
            /*break*/
            , 6];

          case 6:
            _i++;
            return [3
            /*break*/
            , 2];

          case 7:
            return [2
            /*return*/
            , new Promise(function (resolve, reject) {
              if (clientConfiguration) {
                resolve(clientConfiguration);
              } else {
                reject(exception);
              }
            })];
        }
      });
    });
  };

  ApiClient.prototype.sendMessage = function (token, message, sendUrl) {
    return this.relayClient.sendMessage(token, message, sendUrl);
  };

  ApiClient.prototype.subscribeToMessages = function (token, messageHandler, relayErrorHandler, relayEventHandler, receiveUrl) {
    return this.relayClient.subscribeToMessages(token, messageHandler, relayErrorHandler, relayEventHandler, receiveUrl);
  };

  return ApiClient;
}();

export { ApiClient };